import { TaskStatusType } from '@riskbase/types';
import { differenceInCalendarDays } from 'date-fns';
import { UI_DATE_FORMAT_LONG } from 'lib/constants';
import { formatDate } from 'lib/riskbase';
import { theme } from 'lib/theme';

export function getDueDateLabel(dueDate: string | null): string {
  return dueDate
    ? formatDate(new Date(dueDate), UI_DATE_FORMAT_LONG)
    : 'No Due Date';
}

export function getDueDateIconColor(dueDate: string | null): string {
  if (!dueDate) {
    return theme.colors.black30;
  }
  const date = new Date(dueDate);
  const days = differenceInCalendarDays(date, new Date());
  if (days <= 1) {
    return theme.colors.red;
  }
  return theme.colors.text;
}

export function getStatusIconColor(status: TaskStatusType | null): string {
  switch (status) {
    case TaskStatusType.completed:
      return theme.colors.green;
    case TaskStatusType.inProgress:
      return theme.colors.blue;
    case TaskStatusType.evidenceSubmitted:
      return theme.colors.orange;
    case TaskStatusType.cancelled:
      return theme.colors.red;
    case TaskStatusType.notStarted:
    default:
      return theme.colors.textBlack64;
  }
}
